const INITIAL_STATE = {
    totalPrice: 0,
    currencySymbol: "",
    nrExcursions: 0,
    excursions: null,
    notBookableEntries: {excursions:[], tac: []},
    tac: {},
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_CART':
            return {
                totalPrice: action.cart.totalPrice,
                currencySymbol: action.cart.currencySymbol,
                nrExcursions: action.cart.nrExcursions,
                excursions: action.cart.excursions,
                notBookableEntries: action.cart.notBookableEntries,
                tac: action.cart.tacEntries,
            };

        case 'CLEAR_CART':
            return INITIAL_STATE;

        default:
            return state;
    }
}
